@if (pia) {
<app-preview [pia]="pia" [onlyData]="false"> </app-preview>
}
